// Keep runtime/bundler details out of player-facing alerts. Preserve useful
// validation messages such as a closed pick window or an already-used team.
export default function terminatorErrorMessage(error) {
  const message = typeof error?.message === 'string' ? error.message.trim() : ''
  const technical = ['TypeError', 'ReferenceError', 'SyntaxError', 'RangeError'].includes(error?.name) ||
    /WEBPACK|__IMPORT|node_modules|is not a function|is not defined|Cannot (read|set|access)|undefined is not|Unexpected token|<html|<!doctype/i.test(message)
  if (technical || !message || message.length > 300) {
    return 'This feature is temporarily unavailable. Please reload the app. If the problem continues, contact an administrator.'
  }
  return message
}
